import { render, staticRenderFns } from "./EntityFlags.vue?vue&type=template&id=7131ef32&"
import script from "./EntityFlags.vue?vue&type=script&lang=js&"
export * from "./EntityFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports